<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-02-23 13:54:22
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-03-01 16:51:07
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/multilingual/components/MainPageResume.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div :class="customClass" class="bg-white  mt-10 br-10 pt-15 px-12 pb-12 border-box text-left">
    <div class="cor-262626 fz-17 fw-7 mr-6">{{title}}</div>
    <template v-for="(item, index) in recordVos">
      <!-- （{{item.timeInterval}}） -->
      <div class="cor-595959 fz-12  mt-25">{{item.startTime}} - {{item.endTime}}</div>
      <div class=" bg-F5F5F5 mt-6 px-10 pt-12 pb-10 br-10 border-box">
        <div class="cor-262626 fz-17 fw-7">{{item.company}}</div>
        <div class="cor-262626 fz-14 mt-3">{{item.position}}</div>
        <div class="cor-9E9E9E fz-14 mt-14 text-wrap ">{{item.workContent}}</div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'MainPageResume',
  props: {
    customClass: {
      type: String,
      default: 'mx-12',
    },
    title: {
      type: String,
      default: 'Work Experience',
    },
    recordVos: {
      type: Array,
      default: [],
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {},
  mounted() {},
}
</script>
